export default "__VITE_ASSET__k0q6mzc$__"